import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {Cohort} from "../../model/cohort";

@Component({
  selector: 'gen-cohort-viewer',
  templateUrl: './cohort-viewer.component.html',
  styleUrls: ['./cohort-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CohortViewerComponent {

  @Input() cohort: Cohort;
  @Input() allowEdit: boolean;
  @Input() curationStatus: string;    // draft, waitforapproval, approved, rejected
  @Input() enableCohortDragging: boolean;
  @Output() editMe = new EventEmitter();
  @Output() cloneMe = new EventEmitter();
  visible: boolean;

  private readonly DRAFT = "draft";
  public listName: string = "criterion-viewer-items";

  constructor() {
    this.visible = true;
  }

  ngOnInit() {
    if (this.curationStatus === undefined)
      this.curationStatus = this.DRAFT;
  }

  enterEditMode() {
    this.editMe.emit();
  }

  onCloneMe() {
    this.cloneMe.emit(this.cohort);
  }

  getDrugs(): string {
    if (!this.cohort.info.drugs || this.cohort.info.drugs.length == 0) return '';
    if (this.cohort.info.drugs.length == 1) return this.cohort.info.drugs[0].CommonName;
    return this.cohort.info.drugs.map(x => x.CommonName).join(', ');
  }

  get editMode(): boolean {
    return this.curationStatus === this.DRAFT;
  }


}
